import { FieldDescription } from '@app/entity';

export const VETERANS_FIELDS: FieldDescription[] = [
  { name: 'last_name', type: 'text', is_required: true, label: 'Фамилия', placeholder: 'Введите вашу фамилию' },
  { name: 'first_name', type: 'text', is_required: true, label: 'Имя', placeholder: 'Введите ваше имя' },
  { name: 'middle_name', type: 'text', is_required: true, label: 'Отчество', placeholder: 'Введите ваше отчество' },
  { name: 'city_text', type: 'text', is_required: true, label: 'Город', placeholder: 'Введите ваш город проживания' },
  { name: 'phone', type: 'phone', is_required: true, label: 'Номер телефона', placeholder: 'Введите ваш номер телефона' },
  { name: 'email', type: 'email', is_required: true, label: 'Email', placeholder: 'Введите вашу электронную почту' },
  { name: 'password', type: 'password', is_required: true, label: 'Пароль', placeholder: 'Придумайте пароль' },
  { name: 're-password', type: 'password', is_required: true, label: 'Повторите пароль', placeholder: 'Повторите пароль' },
  // { name: 'birth_date', type: 'custom_input', is_required: true, label: 'День рождения', half_width: true },
  // { name: 'category_ids', type: 'custom_input', label: 'Категория', is_required: true },
  // { name: 'categories', type: 'hidden' },
  // { name: 'citizenship_id', type: 'custom_input', label: 'Гражданство', placeholder: 'Укажите гражданство', is_required: true },
  // { name: 'family', type: 'custom_input', label: 'Члены вашей семьи' },
  // { name: 'document_number', type: 'text', is_required: true, label: 'Серия и номер удостоверения ветерана',
  //   placeholder: 'Введите серию и номер удостоверения ветерана' },
  { name: 'agreement', label: `Даю согласие на обработку <a href="/agreement" target="_blank" rel="noopener">персональных данных</a>.`,
    type: 'checkbox', default: false, is_required: true },
];



// WEBPACK FOOTER //
// ./src/app/accounts/register-page/veterans.fields.ts